import {adbApi} from "./adbService";

export const notificationPageApi = adbApi.injectEndpoints({
    endpoints: (builder) => ({
        getNotificationPage: builder.query({
            query: () => ({
                url: "pages/notification-center",
                method: "GET",
            }),
            invalidatesTags: ["NotificationPage"],
        }),
        getAccountProjects: builder.query({
            query: () => ({
                url: "account/projects",
                method: "GET",
            }),
            invalidatesTags: ["AccountProjects"],
        }),
        setIsUserToggleNotify: builder.mutation({
            query: () => ({
                url: "account/toggle-notify",
                method: "POST",
            }),
            invalidatesTags: ["NotificationPage"],
        }),
        setProjectToggleNotify: builder.mutation({
            query: (projectId) => ({
                url: `notification-center/project/toggle-notify/${projectId}`,
                method: "POST",
            }),
            invalidatesTags: ["NotificationPage"],
        }),
        getAllNotifications: builder.query({
            query: () => ({
                url: `notification-center`,
                method: "GET",
            }),
            invalidatesTags: ["NotificationPage"],
        }),
        getNotifByProject: builder.query({
            query: (projectId) => ({
                url: `notification-center/project/${projectId}`,
                method: "GET",
            }),
            invalidatesTags: ["NotificationPage"],
        }),
        updateSectionNotify: builder.mutation({
            query: (sectionId) =>({
                url: `notification-center/project/section/toggle-notify/${sectionId}`,
                method: "POST",
            }),
            invalidatesTags: ["NotificationPage"],
        }),
        updateSectionItemNotify: builder.mutation({
            query: (notificationId) =>({
                url: `notification-center/project/section/notification/toggle-notify/${notificationId}`,
                method: "POST",
            }),
            invalidatesTags: ["NotificationPage"],
        }),
        updateNotificationTriggers: builder.mutation({
            query: ({notificationId, body}) =>({
                url: `notification-center/project/section/notification/triggers-update/${notificationId}`,
                method: "POST",
                body
            }),
            invalidatesTags: ["NotificationPage"],
        }),
        copyNotifications: builder.mutation({
            query: ({projectId, body}) =>({
                url: `notification-center/project/copy/${projectId}`,
                method: "POST",
                body
            })
        }),
    }),
    overrideExisting: false,
});

export const {
    useLazyGetNotificationPageQuery,
    useLazyGetAccountProjectsQuery,
    useSetIsUserToggleNotifyMutation,
    useSetProjectToggleNotifyMutation,
    useLazyGetAllNotificationsQuery,
    useLazyGetNotifByProjectQuery,
    useUpdateSectionNotifyMutation,
    useUpdateSectionItemNotifyMutation,
    useUpdateNotificationTriggersMutation,
    useCopyNotificationsMutation,
} = notificationPageApi;
